var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{attrs:{"id":"nav"}},[_c('NavBar')],1),_c('vue-page-transition',{attrs:{"name":"fade-in-up"}},[_c('router-view')],1),_c('NewFooter'),_c('CookieBanner')],1)}
var staticRenderFns = []

export { render, staticRenderFns }